import { useEffect, useRef } from "react";
import { testimonials } from "../data/siteData";
import "./Testimonials.css";

export default function Testimonials() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
  }, []);

  return (
    <section className="section testimonials" ref={ref}>
      <div className="reveal" style={{ textAlign: "center", maxWidth: 560, margin: "0 auto 4rem" }}>
        <span className="section-eyebrow">Field Results</span>
        <h2 className="section-title">Trusted by Growers<br /><em>Worldwide</em></h2>
      </div>
      <div className="testi__grid reveal">
        {testimonials.map((t) => (
          <div className="testi-card" key={t.name}>
            <div className="testi-card__quote">"</div>
            <div className="testi-card__stars">{"★".repeat(t.stars)}</div>
            <p className="testi-card__text">{t.text}</p>
            <div className="testi-card__author">
              <div className="testi-card__avatar">{t.avatar}</div>
              <div>
                <div className="testi-card__name">{t.name}</div>
                <div className="testi-card__role">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
